module.exports = __webpack_public_path__ + "img/kiosk-carrefour-estrie-search.ebe66741.webp";